import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import BadgeAndCertificates from "@pages/Contents/BadgeAndCertificates";
import Certificates from "@pages/Contents/BadgeAndCertificates/Certificates";
import Badge from "@pages/Contents/BadgeAndCertificates/Badge";
import AddBadge from "@pages/Contents/BadgeAndCertificates/Badge/AddBadge";
import EditBadge from "@pages/Contents/BadgeAndCertificates/Badge/EditBadge";
import EditCertificates from "@pages/Contents/BadgeAndCertificates/Certificates/EditCertificates";
import AddCertificates from "@pages/Contents/BadgeAndCertificates/Certificates/AddCertificates";
import SkillBook from "@pages/Contents/BadgeAndCertificates/SkillBook";
import AddSkillBook from "@pages/Contents/BadgeAndCertificates/SkillBook/Completions/AddSkillBook";
import { SkillBookStateProvider } from "@pages/Contents/BadgeAndCertificates/context/SkillBookContext";
import ManageRequests from "@pages/Contents/BadgeAndCertificates/SkillBook/Completions/ManageRequests";

const useBadgeCertificatesRoutes = () => {
  const { isInclude } = useIsInclude();
  return {
    path: "badge-certificates",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("badge-certificates&&fe.badge.template.read")}
          >
            <BadgeAndCertificates />
          </ProtectedRoute>
        ),
      },
      {
        path: "certificates",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.read",
                )}
              >
                <Certificates />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.read&&fe.certificate.template.write",
                )}
              >
                <AddCertificates />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idCertificate",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.certificate.template.read&&fe.certificate.template.write",
                )}
              >
                <EditCertificates />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "badges",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.read",
                )}
              >
                <Badge />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.read&&fe.badge.template.write",
                )}
              >
                <AddBadge />
              </ProtectedRoute>
            ),
          },
          {
            path: "edit/:idBadge",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.read&&fe.badge.template.write",
                )}
              >
                <EditBadge />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "skillBook",
        children: [
          {
            index: true,
            path: "",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.external.certificate.read",
                )}
              >
                <SkillBook />
              </ProtectedRoute>
            ),
          },
          {
            path: "add",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "badge-certificates&&fe.badge.template.read&&fe.external.certificate.write",
                )}
              >
                <SkillBookStateProvider>
                  <AddSkillBook />
                </SkillBookStateProvider>
              </ProtectedRoute>
            ),
          },
          {
            path: "manage-requests",
            element: (
              <ProtectedRoute isAllowed={isInclude("badge-certificates")}>
                <ManageRequests />
              </ProtectedRoute>
            ),
          },
          {
            path: ":userId/manage-requests",
            element: (
              <ProtectedRoute isAllowed={isInclude("badge-certificates")}>
                <ManageRequests />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  };
};

export default useBadgeCertificatesRoutes;
